import { CookieConsent } from './cookie-consent/CookieConsent'

const API_URL = import.meta.env.VITE_API_URL || 'https://api.vestirstudio.com/api'

const LABELS = {
  title: 'Utilizamos cookies',
  description:
    'Usamos cookies para melhorar sua experiência, analisar o uso do site e personalizar conteúdo. Você pode aceitar todos, recusar os não essenciais ou personalizar suas preferências.',
  acceptAll: 'Aceitar todos',
  rejectAll: 'Apenas necessários',
  customize: 'Personalizar',
  settings: {
    necessary: 'Necessários',
    necessaryDesc: 'Essenciais para o funcionamento do site. Não podem ser desativados.',
    analytics: 'Analíticos',
    analyticsDesc: 'Nos ajudam a entender como você usa o site para melhorar a experiência.',
    functional: 'Funcionais',
    functionalDesc: 'Permitem lembrar suas preferências como idioma e tema.',
    marketing: 'Marketing',
    marketingDesc: 'Utilizados para exibir conteúdo e anúncios relevantes.',
    save: 'Salvar preferências',
    alwaysActive: 'Sempre ativo',
  },
}

export const CookieConsentBanner = () => (
  <CookieConsent labels={LABELS} apiUrl={API_URL} sourceApp="admin" />
)
